/*
 *
 * AbsenceMobile reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE_ABSENCEMOBILE,
  LOAD_ABSENCES,
  LOAD_ABSENCES_SUCCESS,
  LOAD_ABSENCES_ERROR,
  CHANGE_ABSENCE,
  CHANGE_ABSENCE_SUCCESS,
  CHANGE_ABSENCE_ERROR,
  DELETE_ABSENCE,
  DELETE_ABSENCE_SUCCESS,
  DELETE_ABSENCE_ERROR,
} from './constants';

export const initialState = {
  loading: false,
  error: false,
  deleteSuccessful: false,
  role: false,
  child: false,
  absenceList: false,
  absenceData: false,
};

/* eslint-disable default-case, no-param-reassign */
const absenceMobileReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_ABSENCEMOBILE:
        return initialState;

      // LOAD
      case LOAD_ABSENCES:
        draft.loading = true;
        draft.error = false;
        draft.absenceList = false;
        draft.role = action.role;
        draft.child = action.child;
        break;

      case LOAD_ABSENCES_SUCCESS:
        draft.absenceList = action.absenceList;
        draft.loading = false;
        break;

      case LOAD_ABSENCES_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.absenceList = false;
        break;

      // CHANGE/UPDATE
      case CHANGE_ABSENCE:
        draft.absenceData = {
          ...state.absenceData,
          ...action.absenceData,
        };
        draft.loading = true;
        draft.error = false;
        break;

      case CHANGE_ABSENCE_SUCCESS:
        draft.loading = false;
        const { absenceData } = action;
        draft.absenceData = absenceData;

        // update single item in the list inside state
        let listData = draft.absenceList.data;
        let index = draft.absenceList.data.findIndex(
          po => po._id === absenceData._id,
        );
        index !== -1
          ? (listData[index] = absenceData)
          : listData.unshift(absenceData);
        draft.absenceList = {
          ...draft.absenceList,
          data: listData,
        };

        break;

      case CHANGE_ABSENCE_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // DELETE
      case DELETE_ABSENCE:
        draft.loading = true;
        draft.id = action.id;
        break;

      case DELETE_ABSENCE_SUCCESS:
        draft.loading = false;
        draft.deleteSuccessful = true;
        break;
    }
  });

export default absenceMobileReducer;
